export default {
      id: "menu-usage",
      viewBox: "0 0 15 13",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#menu",
      toString: function () {
        return this.url;
      }
    }